import { type ReportGroupAvailability, type ReportGroupReason } from '@apm/contracts';

/**
 * Hai lý do vắng mặt, hai cách xử lý — APM-REPORT-g.
 *
 * - **Không áp dụng cho loại dự án này** (`not_maintenance`, `no_end_date`): ẩn
 *   hẳn. Nhóm Bảo trì trên một dự án Agile sẽ **không bao giờ** có nội dung,
 *   nên một khung rỗng ở đó là khung vĩnh viễn rỗng.
 * - **Điều kiện chưa đạt** (`no_baseline`, `no_tasks`, …): vẫn hiện, và nói ra
 *   cần gì. Người dùng bấm một nút là nó chạy — giấu nó đi là giấu mất chính
 *   cái nút ấy.
 *
 * Bản trước gộp hai chuyện làm một và ẩn cả hai, nên "chưa chốt kế hoạch gốc"
 * đọc thành "sản phẩm không có báo cáo EVM".
 *
 * ## Vì sao là module riêng
 *
 * `ReportsPanel` dựng năm truy vấn và hai chục biểu đồ, nên kiểm quyết định này
 * qua lớp vẽ là kiểm qua một lớp dày. Đã thử một lần và test ấy **xanh dưới đột
 * biến** (APM-REPORT-d) — tức nó không kiểm gì cả. Tách ra thì phần ra quyết
 * định kiểm được bằng dữ liệu, và panel chỉ còn việc gọi.
 */
const NOT_APPLICABLE: readonly ReportGroupReason[] = ['not_maintenance', 'no_end_date'];

/**
 * Nhóm này có hiện trên trang không.
 *
 * ⚠️ `undefined` = chưa biết ⇒ **coi như có**. Ẩn trước khi biết thì mỗi lần mở
 * tab cả trang nhấp nháy: năm mục hiện ra rồi hai mục biến mất, và mục người
 * dùng đang nhắm chuột vào trượt đi dưới tay họ.
 */
export function showsGroup(row: ReportGroupAvailability | undefined): boolean {
  if (row === undefined || row.available) return true;
  return row.reason === null || !NOT_APPLICABLE.includes(row.reason);
}

/** Nhóm hiện ra nhưng **chưa chạy được** — lý do, để nói ra cần điều kiện gì. */
export function pendingReason(row: ReportGroupAvailability | undefined): ReportGroupReason | null {
  return row === undefined || row.available ? null : row.reason;
}
